<template lang="pug">
  .component-reveal
    .trigger(@click='openModal')
      slot(name="trigger")

    .modal-component(:id="'mod-'+_uid", :ref="'mod-'+_uid")
      .modal-mask(v-if="showModal || value")
        .modal-wrapper
          .modal-container
            .modal-header
              .text-right.close
                i.fa.fa-times(@click="close")

              slot(name='header')
            .modal-body
              slot
            .modal-footer
              slot(name='footer')

    //.reveal(:class="sizing", :id="id", data-reveal="", :data-reset-on-close="resetOnClose")
      button.close-button(data-close="", type="button")
        span(aria-hidden="true") &times;
      slot
    //.trigger(:data-open="id", data-toggle="")
      slot(name="trigger")
        span Open the modal
</template>
<script type="text/babel">
import {EventBus} from "src/eventBus";

export default {
  name: 'ModalReveal',
  components: {},
  data() {
    return {
      showModal: false,
    }
  },
  watch: {
    value: function (val) {
      if (val) {
        this.openModal()
      } else {
        this.close()
      }
    }
  },
  destroyed() {
    EventBus.$off('close-modal')
  },
  created() {
    EventBus.$on('close-modal', () => {
      this.close()
    })
  },
  methods: {
    close() {
      this.$emit('input', false)
      this.showModal = false
      const destroyFast = container => {
        const el = document.getElementById(container)
        while (el.firstChild) {
          if (`${el.firstChild.id}` === `mod-${this._uid}`) {
            el.removeChild(el.firstChild)
          }
          break;
        }
      }
      destroyFast('global-modal-container')
    },

    openModal() {
      this.showModal = true
      document.getElementById('global-modal-container').appendChild(this.$refs['mod-' + this._uid])
      this.$emit('modalOpen')
    }
  },
  props: {
    sizing: {
      type: String,
      default: 'large'
    },
    id: {
      type: String,
      default: function () {
        return 'r-' + this._uid
      }
    },
    resetOnClose: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

.modal-component
  .modal-mask
    position: fixed
    z-index: 500
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.5)
    display: table
    transition: opacity .3s ease

  .modal-wrapper
    display: table-cell
    vertical-align: middle

  .modal-container
    height: 80%
    overflow-y: auto
    width: 50%
    @media (max-width: 700px)
      width: 100%
    margin: 0 auto
    padding: 20px 30px
    background-color: #fff
    border-radius: 2px
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33)
    transition: all .3s ease
    text-align: left !important

  .modal-header h3
    margin-top: 0
    color: #42b983

  .close
    cursor: pointer

  .modal-body
    margin: 20px 0

  .modal-footer
    display: flex
    justify-content: space-between
    margin-top: 50px

  .modal-default-button
    float: right

  .modal-enter, .modal-leave-active
    opacity: 0

  .modal-enter .modal-container, .modal-leave-active .modal-container
    -webkit-transform: scale(1.1)
    transform: scale(1.1)
</style>



// WEBPACK FOOTER //
// ModalReveal.vue?6ab38b9e